// Context.js
import React, { createContext, useState, useContext } from "react";
import Cookies from "js-cookie";

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
 
  const [subTerPopup, setSubTerPopup] = useState(false);
  const [upgradePopup, setUpgradePopup] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen((prev) => !prev);
  };

  const toggleSubTerPopup = (set=false) => {
    if(set){
      setSubTerPopup(false);
    }
    else{
      setSubTerPopup(true);
    }
  }

  const toggleUpgradePopup = (set=false) => {
    if(set){
      setUpgradePopup(false);
    }else{
      setUpgradePopup(true);
    }
    
  }

  const userId = Cookies.get("userId") || 0
  // set this to true to show the ai analize component 
  const isBackendCompleted = true //userId === "155" ? true : false; // 155
  // set this to true to show the ai analize component 

  return (
    <PopupContext.Provider value={{ isPopupOpen, togglePopup, subTerPopup, toggleSubTerPopup, upgradePopup, toggleUpgradePopup,isBackendCompleted }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
